import React from 'react';
export interface Stat {
  value: string;
  label: string;
}
interface StatGroupProps {
  stats: Stat[];
  className?: string;
}

/**
 * StatGroup — a row of headline metrics divided by hairlines. Inherits text
 * colour from its container so it works on brand panels and plain surfaces.
 */
export const StatGroup: React.FC<StatGroupProps> = ({
  stats,
  className = ''
}) => <div className={`grid gap-4 py-6 border-y border-white/20 ${className}`} style={{
  gridTemplateColumns: `repeat(${stats.length}, minmax(0, 1fr))`
}} data-id="element-3423" data-mp="1t0vek8g0g7ao">
    {stats.map((stat, index) => <div key={stat.label} className={`text-center ${index > 0 ? 'border-l border-white/20' : ''}`} data-id="element-3424" data-mp="1k8jquuca6xye" data-mpi={index}>
        <div className="text-2xl font-black" data-id="element-3425" data-mp="1o9dgpt9aamtx">{stat.value}</div>
        <div className="text-xs uppercase tracking-wider opacity-80 mt-1" data-id="element-3426" data-mp="1o7sls2j251vj">
          {stat.label}
        </div>
      </div>)}
  </div>;
export default StatGroup;